import { createServerFn } from "@tanstack/react-start";
import { loadRanking } from "@/lib/rankings.server";

export const getRankingPage = createServerFn({ method: "GET" })
  .inputValidator((data: { slug: string }) => data)
  .handler(async ({ data }) => await loadRanking(data.slug, 25));
